import { SnackbarProvider, SnackbarProviderProps } from 'notistack';
import { ReactNode } from 'react';

const NOTISTACK_OPTIONS: Omit<SnackbarProviderProps, 'children'> = {
  maxSnack: 2,
  anchorOrigin: {
    horizontal: 'right',
    vertical: 'bottom',
  },
  autoHideDuration: 3000,
};

export function ToastProvider({ children }: { children?: ReactNode }) {
  const options = {
    ...NOTISTACK_OPTIONS,
  };
  return <SnackbarProvider {...options}>{children}</SnackbarProvider>;
}
